module.exports = __webpack_public_path__ + "assets/img/mobtmn-bg.27d22eaa.png";